import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: i18n.t('pages_router_index_135')
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/modules/login/login.vue')
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    meta: {
      title: i18n.t('pages_router_index_136')
    },
    component: () => import(/* webpackChunkName: "loginPage" */ '../views/modules/login/loginPage.vue')
  },
  {
    path: '/welinkBind',
    name: 'welinkBind',
    meta: {
      title: i18n.t('pages_router_index_137')
    },
    component: () => import( /* webpackChunkName: "welinkBind" */ '../views/modules/login/welinkBind.vue')
  },
  {
    path: '/welinkCode',
    name: 'welinkCode',
    meta: {
      title: i18n.t('pages_router_index_138')
    },
    component: () => import( /* webpackChunkName: "welinkCode" */ '../views/modules/login/welinkCode.vue')
  },
  {
    path: '/course/home/:id',
    name: 'courseHome',
    component: () => import(/* webpackChunkName: "courseHome" */ '../views/modules/textbook/course.vue')
  },
  {
    path: '/courseDeclaration',
    name: 'courseDeclaration',
    meta: {
      title: i18n.t('pages_router_index_139')
    },
    component: () => import(/* webpackChunkName: "courseDeclaration" */ '../views/modules/textbook/courseDeclaration.vue')
  },
  {
    path: '/term/manager',
    name: 'termManager',
    meta: {
      title: i18n.t('pages_router_index_140')
    },
    component: () => import(/* webpackChunkName: "termManager" */ '../views/modules/textbook/termManager.vue')
  },
  {
    path: '/courseFile',
    name: 'courseFile',
    meta: {
      title: i18n.t('pages_router_index_141')
    },
    component: () => import(/* webpackChunkName: "courseFile" */ '../views/modules/course/courseFile.vue')
  },
  {
    path: '/teaCourseFile',
    name: 'teaCourseFile',
    meta: {
      title: i18n.t('pages_router_index_142')
    },
    component: () => import(/* webpackChunkName: "teaCourseFile" */ '../views/modules/course/teaCourseFile.vue')
  },
  {
    path: '/virtual/grade',
    name: 'virtualGrade',
    meta: {
      title: i18n.t('virtual.grade')
    },
    component: () => import(/* webpackChunkName: "virtualGrade" */ '../views/modules/virtual/grade.vue')
  },{
    path: '/virtual/experiment/detail',
    name: 'experimentDetail',
    meta: {
      title: i18n.t('pages_router_index_143')
    },
    component: () => import(/* webpackChunkName: "experimentDetail" */ '../views/modules/virtual/experimentDetail.vue')
  },
  {
    path: '/virtual/home/:id',
    name: 'virtualHome',
    meta: {
      title: i18n.t('pages_router_index_144')
    },
    component: () => import(/* webpackChunkName: "virtualHome" */ '../views/modules/virtual/home.vue')
  },
  {
    path: '/virtual/courseList',
    name: 'virtualCourseList',
    meta: {
      title: i18n.t('pages_router_index_145')
    },
    component: () => import(/* webpackChunkName: "virtualCourseList" */ '../views/modules/virtual/courseList/index.vue')
  },
  {
    path: '/virtual/homePage/:id/:router',
    name: 'virtualHomePage',
    meta: {
      title: i18n.t('pages_router_index_146')
    },
    component: () => import(/* webpackChunkName: "virtualHomePage" */ '../views/modules/virtual/homePage/index.vue')
  },
  {
    path: '/virtual/coursePage/:id',
    name: 'coursePage',
    meta: {
      title: i18n.t('pages_router_index_147')
    },
    component: () => import(/* webpackChunkName: "coursePage" */ '../views/modules/virtual/coursePage/index.vue')
  },
  {
    path: '/virtual/experimentPage/:id',
    name: 'experimentPage',
    meta: {
      title: i18n.t('pages_router_index_148')
    },
    component: () => import(/* webpackChunkName: "experimentPage" */ '../views/modules/virtual/experimentPage/index.vue')
  },
  {
    path: '/scanSignature',
    name: 'scanSignature',
    meta: {
      title: i18n.t('pages_router_index_149')
    },
    component: () => import(/* webpackChunkName: "scanSignature" */ '../views/modules/scanSignature/index.vue')
  },
  {
    path: '/experiment/teaView/:id',
    name: 'experimentTeaView',
    meta: {
      title: i18n.t('pages_router_index_150')
    },
    component: () => import(/* webpackChunkName: "experimentTeaView" */ '../views/modules/virtual/experimentTeaView.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

export default router
